import { render, staticRenderFns } from "./AdminPredefinedProductCategoriesScreen.vue?vue&type=template&id=13846867&scoped=true&"
import script from "./AdminPredefinedProductCategoriesScreen.vue?vue&type=script&lang=js&"
export * from "./AdminPredefinedProductCategoriesScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13846867",
  null
  
)

export default component.exports